import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M11.097 13.364a.483.483 0 0 1 0-.664l1.046-.997H2.742a.47.47 0 1 1 0-.94h9.402L11.098 9.71a.472.472 0 0 1 .67-.665l1.825 1.825a.458.458 0 0 1 .137.332.452.452 0 0 1-.137.332l-1.825 1.83a.483.483 0 0 1-.67 0ZM3.41 5.504a.476.476 0 0 1 .33-.14.476.476 0 0 1 .47.47v2.151a.47.47 0 0 1-.94 0v-2.15a.476.476 0 0 1 .14-.33Zm2.94-1.41a.476.476 0 0 1 .33-.14v-.018a.476.476 0 0 1 .471.47v3.579a.47.47 0 1 1-.94 0v-3.56a.476.476 0 0 1 .14-.331Zm2.94-1.436a.476.476 0 0 1 .331-.14V2.5a.477.477 0 0 1 .47.489v5.015a.47.47 0 0 1-.94 0V2.989a.476.476 0 0 1 .14-.33Z';
const draw24px =
  'M15.45 2.458a.76.76 0 0 0-.75.75v8a.75.75 0 0 0 1.5 0v-8a.76.76 0 0 0-.75-.78v.03Zm-5.53 2.29a.76.76 0 0 0-.75.75v5.68a.75.75 0 0 0 1.5 0v-5.71a.76.76 0 0 0-.75-.75v.03Zm-5.53 2.25a.76.76 0 0 0-.75.75v3.43a.75.75 0 0 0 1.5 0v-3.43a.76.76 0 0 0-.75-.75Zm12.55 14.357a.77.77 0 0 1-.21-.53.74.74 0 0 1 .21-.53l1.67-1.59h-15a.75.75 0 1 1 0-1.5h15l-1.67-1.68a.753.753 0 1 1 1.07-1.06l2.91 2.91a.73.73 0 0 1 .22.53.721.721 0 0 1-.22.53l-2.91 2.92a.77.77 0 0 1-1.07 0Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const SortRightIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'sortRight'),
) as IconWithRender;

SortRightIcon.displayName = 'SortUpIcon';
SortRightIcon.renderIcon = (props) => <SortRightIcon {...props} />;
export default SortRightIcon;
